import { useCallback, useEffect, useState } from 'react';

import { ICollaboratorDataRF } from '../../interfaces/collaborators';
import Companies from '../../services/api/collaborators/collaborators';
import { useIsMounted } from '../useIsMounted';

interface ICollaboratorDataRFState {
  data: ICollaboratorDataRF | undefined;
  isLoading: boolean;
  error: boolean;
}

const useCollaboratorRFData = (companyId: string, email: string, enabled: boolean) => {
  const [rfDataState, setRfDataState] = useState<ICollaboratorDataRFState>({
    data: undefined,
    isLoading: enabled,
    error: false
  });

  const isMounted = useIsMounted();

  const fetchData = useCallback(async () => {
    setRfDataState((prevState) => ({ ...prevState, isLoading: true, error: false }));

    let response: ICollaboratorDataRF | undefined = undefined;
    let hasError = false;

    try {
      response = await Companies.getCollaboratorDataRF(email, companyId);
    } catch {
      hasError = true;
    } finally {
      if (isMounted) {
        setRfDataState((prevState) => ({
          ...prevState,
          isLoading: false,
          error: hasError,
          data: hasError ? prevState.data : response
        }));
      }
    }
  }, [companyId, email, isMounted]);

  useEffect(() => {
    if (!enabled) {
      setRfDataState({ data: undefined, isLoading: false, error: false });
      return;
    }
    fetchData();
  }, [fetchData, enabled]);

  return { rfDataState, refetchData: fetchData };
};

export default useCollaboratorRFData;
